module.exports = __webpack_public_path__ + "static/img/暂无就诊人信息@2x.c2a2d83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/暂无就诊人信息@2x.png
// module id = 294
// module chunks = 379 380